// ----------------------------------------------------------------------
// <copyright file="Izenda.Popover.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Popover Component
 * Note:
 * - Children of popover can call this.props.hidePopover() method to hide the popover.
 * - Should to supply the position {left, top} of popover.
 *
 * Usage example:
 *  var Button = function (props) {
 *    var onClick = function () {
 *      props.hidePopover();
 *    };
 *    return (
 *      <button
 *        className='btn btn-default'
 *        onClick={onClick}>
 *        {props.label}
 *      </button>
 *    );
 *  };
 *
 *  <Popover
 *    visible={true}
 *    positionLeft={500}
 *    positionTop={200}
 *    title={'Popover Title'}
 *    hasArrow={true}
 *    placement={PopoverOptions.PLACEMENT.RIGHT}
 *    arrowOffsetTop={'50%'}>
 *    <Button label={'Click me to hide Popover...'} />
 *  </Popover>
 */

!(function() {
  var React = require('react');
  var ReactDOM = require('react-dom');
  var classnames = require('classnames');
  const { omit } = require('lodash/fp');
  var PopoverTitle = function(props) {
    return props.title ? <h3 className="popover-title">{props.title}</h3> : null;
  };

  var PopoverArrow = function(props) {
    var arrowStyle = {
      left: props.arrowOffsetLeft,
      top: props.arrowOffsetTop
    };

    return props.hasArrow ? <div className="arrow" style={arrowStyle} /> : null;
  };

  var PLACEMENT = {
    TOP: 'top',
    RIGHT: 'right',
    BOTTOM: 'bottom',
    LEFT: 'left'
  };

  var Popover = React.createClass({
    propsType: {
      /**
       * Sets the direction the Popover is positioned towards.
       */
      placement: React.PropTypes.oneOf([PLACEMENT.TOP, PLACEMENT.RIGHT, PLACEMENT.BOTTOM, PLACEMENT.LEFT]),

      /**
       * The "left" position value for the Popover.
       */
      positionLeftPixel: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string]),

      /**
       * The "top" position value for the Popover.
       */
      positionTopPixel: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string]),

      /**
       * The "left" position value for the Popover arrow.
       */
      arrowOffsetLeft: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string]),

      /**
       * The "top" position value for the Popover arrow.
       */
      arrowOffsetTop: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string]),

      /**
       * Title text
       */
      title: React.PropTypes.node,

      /**
       * Specify whether the popover should trigger onHide when the user clicks outside the popover
       */
      rootClose: React.PropTypes.bool,

      /**
       * A callback invoked by the popover when it wishes to be hidden. Required if
       * `rootClose` is specified.
       */
      onHide: React.PropTypes.func
    },

    getDefaultProps: function() {
      return {
        placement: PLACEMENT.RIGHT,
        rootClose: false
      };
    },

    getInitialState: function() {
      return {
        isVisible: this.props.visible
      };
    },

    componentWillReceiveProps: function(nextProps) {
      this.setState({
        isVisible: nextProps.visible
      });
    },

    componentDidMount: function() {
      window.addEventListener('mousedown', this.handleDocumentClick, false);
    },

    componentWillUnmount: function() {
      window.removeEventListener('mousedown', this.handleDocumentClick, false);
    },

    handleDocumentClick: function(event) {
      var props = this.props;
      if (this.state.isVisible && this.props.rootClose) {
        var popoverElement = ReactDOM.findDOMNode(this.refs.popover);
        var isInside = popoverElement.contains(event.target) || popoverElement === event.target;

        if (!isInside) {
          this.setState({ isVisible: false });
          props.onHide && props.onHide(event);
        }
      }
    },

    render: function() {
      if (!this.state.isVisible) {
        return null;
      }

      var style = {
        left: this.props.positionLeft,
        top: this.props.positionTop,
        display: 'block',
        zIndex: 1600
      };

      var popoverclassnames = classnames('popover popover-container fade', {
        in: this.state.isVisible
      });

      var rest = omit(['visible', 'positionLeft', 'positionTop', 'onHide', 'rootClose', 'placement'], this.props);

      return (
        <div
          className={popoverclassnames + ' ' + this.buildPlacementClass()}
          role="tooltip"
          ref="popover"
          {...rest}
          style={style}
        >
          <PopoverArrow {...this.props} />
          <PopoverTitle {...this.props} />

          {this.renderContent()}
        </div>
      );
    },

    /**
     * Base on placement value, we build CSS class for popover.
     */
    buildPlacementClass: function() {
      return this.props.placement;
    },

    /**
     * Hide popover
     */
    hide: function() {
      this.setState({
        isVisible: false
      });
    },

    /**
     * Render content of popover.
     */
    renderContent: function() {
      var children = this.props.children;
      if (!children) {
        return null;
      }

      // Send hide popover action into its children then they can hide popover.
      var childrenWithHidePopoverCallback = React.Children.map(
        children,
        function(child) {
          return React.cloneElement(child, {
            hidePopover: this.hide
          });
        }.bind(this)
      );

      return <div className="popover-content">{childrenWithHidePopoverCallback}</div>;
    }
  });

  module.exports = {
    Popover: Popover,
    PopoverOptions: {
      PLACEMENT: PLACEMENT
    }
  };
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.Popover.jsx